import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ParametrosService } from '../../../../services/parametros.service';
import { Parametros } from '../../../../models/parametros.model';
import { MarmorariaAgendamento } from '../../../service/marmoraria.service';
import { formatarMoedaBRL } from '../../../../core/utils/moeda.util';

@Component({
  selector: 'app-romaneio-pdf',
  standalone: true,
  templateUrl: './romaneio-pdf.component.html'
})
export class RomanieioPdfComponent {

  parametrosEspelho: Parametros[] = [];
  constructor(private toastr: ToastrService, 
    private parametros: ParametrosService) {
        parametros.getParametrosByCategorias(['ESPELHO_ORCAMENTO']).subscribe({
        next: (params) => {
            this.parametrosEspelho = params;
          
        },
        error: () => {
          this.toastr.error('Erro ao carregar parâmetros para o romaneio. A logo pode não ser exibida corretamente.');
        }
      });

    }

  printRomaneio(agendamentos: MarmorariaAgendamento[], dataInicio: string, dataFim: string): void {
    const printWindow = window.open('', '_blank');
    

    if (!printWindow) {
      this.toastr.warning('Não foi possível abrir a janela de impressão. Verifique se o bloqueador de pop-up está ativo.');
      return;
    }

    const formatCurrency = (value: number | null | undefined): string => formatarMoedaBRL(value ?? 0);

    const formatDate = (value: string | null | undefined): string => {
      if (!value) return '-';
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? '-' : date.toLocaleDateString('pt-BR');
    };

    const formatPhone = (value: string | null | undefined): string => {
      const digits = String(value ?? '').replace(/\D/g, '');

      if (digits.length === 11) {
        return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      }

      if (digits.length === 10) {
        return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      if (digits.length === 13 && digits.startsWith('55')) {
        return digits.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, '+$1 ($2) $3-$4');
      }

      return value?.trim() || '-';
    };

    const esc = (value: string | number | null | undefined): string => {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

    const agendamentosRows = (agendamentos ?? [])
      .map((agendamento, index) => `
        <tr>
          <td class="center"></td>
          <td>${esc(agendamento.tipoAgendamento)}</td>
          <td>${esc(formatDate(agendamento.dataAgendamento))}</td>
          <td>${esc(agendamento.cliente.nomeRazaoSocial)}</td>
          <td>${esc(agendamento.enderecoAgendamento)}</td>
          <td>${esc(formatPhone(agendamento.telefoneContato))}</td>
          <td class="center">${esc(agendamento.complexidade)}</td>
          <td>${esc(agendamento.descricao)}</td>
          <td class="center"></td>
        </tr>
      `).join('');

    const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8" />
  <title>Romaneio de Entregas</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 12px;
      color: #1e293b;
      background: #e5e7eb;
    }

    .page {
      width: 297mm;
      min-height: 210mm;
      margin: 16px auto 24px;
      background: #fff;
      box-shadow: 0 8px 24px rgba(15,23,42,.15);
      padding: 10mm 12mm 14mm;
    }

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 3px solid #1e3a5f;
      padding-bottom: 14px;
      margin-bottom: 14px;
      gap: 16px;
    }
    .logo-wrap {
      flex-shrink: 0;
      width: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .logo-wrap img {
      max-width: 80px;
      max-height: 80px;
      object-fit: contain;
    }
    .company-center { text-align: center; flex: 1; }
    .company-name  { font-size: 24px; font-weight: 700; color: #3b6bc0; margin-bottom: 4px; }
    .company-details { font-size: 11px; color: #475569; line-height: 1.7; }
    .spacer { width: 80px; flex-shrink: 0; }

    .meta {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
      border-bottom: 1px solid #e2e8f0;
      margin-bottom: 14px;
    }
    .meta-block .lbl { font-weight: 700; font-size: 11px; }
    .meta-block .val { font-size: 11px; color: #475569; margin-top: 2px; }

    .title {
      font-size: 18px;
      font-weight: 700;
      color: #1e3a5f;
      margin-bottom: 12px;
      text-align: center;
    }

    .period-info {
      font-size: 11px;
      color: #475569;
      margin-bottom: 14px;
      text-align: center;
    }

    table { 
      width: 100%; 
      border-collapse: collapse; 
      margin-bottom: 8px;
      font-size: 10px;
    }
    th {
      background: #f1f5f9;
      color: #3b6bc0;
      font-weight: 700;
      font-size: 10px;
      padding: 6px 4px;
      border: 1px solid #cbd5e1;
      text-align: left;
    }
    td {
      border: 1px solid #e2e8f0;
      padding: 5px 4px;
      font-size: 10px;
      vertical-align: top;
    }
    tr:nth-child(even) td { background: #f8fafc; }
    .center { text-align: center; }
    .right  { text-align: right; white-space: nowrap; }

    .summary {
      margin-top: 12px;
      padding-top: 8px;
      border-top: 1px solid #e2e8f0;
      font-size: 11px;
    }
    .summary-item {
      display: flex;
      justify-content: space-between;
      padding: 3px 0;
    }

    .no-print {
      width: 210mm;
      margin: 12px auto 0;
      display: flex;
      justify-content: flex-end;
    }
    .no-print button {
      padding: 8px 14px;
      background: #1e3a5f;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
    }

    @media print {
      body { background: #fff; }
      .no-print { display: none; }
      .page { width: 100%; min-height: auto; margin: 0; box-shadow: none; padding: 0; }
      @page { size: A4 landscape; margin: 10mm; }
    }
  </style>
</head>
<body>
  <div class="no-print">
    <button onclick="window.print()">Imprimir / Salvar PDF</button>
  </div>

  <div class="page">
    <div class="header">
      <div class="logo-wrap">
        <img src="${window.location.origin}/assets/logo/logo_transparente.png" alt="Logo" />
      </div>
      <div class="company-center">
        <div class="company-name">Romaneio de Entregas</div>
        <div class="company-details">
          Relatório de Agendamentos de Visita
        </div>
      </div>
      <div class="spacer"></div>
    </div>

    <div class="title">Romaneio de Entregas</div>
    <div class="period-info">
      Período: ${esc(formatDate(dataInicio))} a ${esc(formatDate(dataFim))}
    </div>

    <table>
      <thead>
        <tr>
          <th class="center" style="width:30px">Seq</th>
          <th style="width:80px">Tipo</th>
          <th style="width:70px">Data</th>
          <th>Cliente</th>
          <th>Endereço</th>
          <th style="width:80px">Fone</th>
          <th style="width:60px">Tamanho</th>
          <th>Descrição</th>
          <th class="center" style="width:70px">Conclusão</th>
        </tr>
      </thead>
      <tbody>
        ${agendamentosRows || '<tr><td colspan="9" class="center">Sem agendamentos neste período</td></tr>'}
      </tbody>
    </table>

    <div class="summary">
      <div class="summary-item">
        <span><strong>Total de Agendamentos:</strong></span>
        <span><strong>${esc(agendamentos?.length ?? 0)}</strong></span>
      </div>
      <div class="summary-item">
        <span>Agendamentos Concluídos:</span>
        <span>${esc((agendamentos ?? []).filter(a => a.dataConclusao).length)}</span>
      </div>
      <div class="summary-item">
        <span>Agendamentos Pendentes:</span>
        <span>${esc((agendamentos ?? []).filter(a => !a.dataConclusao).length)}</span>
      </div>
    </div>
  </div>
  <script>
    window.addEventListener('load', () => { window.focus(); window.print(); });
  </script>
</body>
</html>`;

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
  }
}
